module.exports = __webpack_public_path__ + "img/bu_schueler_500.38113c01.jpg";